import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CategoryList, ListCategoriesQuery } from '@klopotun/contracts';
import { categoryQueries } from './category-queries.js';

export const useCategoriesQuery = (query?: ListCategoriesQuery): UseQueryResult<CategoryList> =>
  useQuery(categoryQueries.list(query));
